import { createAction, createSlice } from "@reduxjs/toolkit";

const changeCourseStatusSlice = createSlice({
  name: "changeCourseStatus",
  initialState: { success: null, processing: false },
  reducers: {
    pending(state) {
      state.success = null;
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.success = true;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = changeCourseStatusSlice;
const changeCourseStatusAction = createAction(name);

export {
  changeCourseStatusAction,
  actions as changeCourseStatusActions,
  reducer as changeCourseStatusReducer,
};
